import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { insertPaymentInstallment } from 'modules/accommodations/features/reservations/api';

export const useMutationInsertPaymentInstallment = () => {
  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { mutateAsync, isLoading, isError, data } = useMutation(insertPaymentInstallment, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_PAYMENT_INSTALLMENT);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_PAYMENT_INSTALLMENT);
      //   successToast(t('Reservation successfully entered'));
      //   navigate('/accommodations/reservations');
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(errorMessage);
    },
  });

  return {
    insertPaymentMutate: mutateAsync,
    paymentLoading: isLoading,
    paymentError: isError,
    paymentData: data,
  };
};
